import classNames from "classnames";
import eyeSlashedIcon from "../../../assets/password-eye-slashed.svg";
import eyeIcon from "../../../assets/password-eye.svg";
import StyledButton from "../../common/buttons/StyledButton";
import styles from "./ShowScriptButton.module.css";

const strings = {
  showScript: "Show Script",
  hideScript: "Hide Script",
};

type Props = {
  showScript: boolean;
  onClick: () => void;
  className?: string;
};

export default function ShowScriptButton({
  showScript,
  onClick,
  className,
}: Props) {
  return (
    <StyledButton
      variant="secondary"
      onClick={onClick}
      className={classNames(styles.button, className)}
    >
      {showScript ? (
        <>
          <img src={eyeSlashedIcon} alt="" className={styles.eyeIcon} />
          {strings.hideScript}
        </>
      ) : (
        <>
          <img src={eyeIcon} alt="" className={styles.eyeIcon} />
          {strings.showScript}
        </>
      )}
    </StyledButton>
  );
}
